var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56145 0.9021C4.30981 0.9021 0.0475464 5.16431 0.0475464 10.416C0.0475464 15.6676 4.30981 19.9299 9.56145 19.9299C14.8227 19.9299 19.0754 15.6676 19.0754 10.416C19.0754 5.16431 14.8227 0.9021 9.56145 0.9021ZM14.1717 7.73842L8.0369 13.7738C7.94399 13.8648 7.82414 13.9104 7.70336 13.9104C7.58258 13.9104 7.46273 13.8648 7.36982 13.7738L4.46641 10.9178C4.27873 10.7338 4.27687 10.4328 4.46083 10.2451C4.64479 10.0565 4.94582 10.0556 5.13349 10.2395L7.70336 12.7676L13.5046 7.06018C13.6923 6.87622 13.9924 6.87715 14.1773 7.06575C14.3612 7.25341 14.3594 7.55444 14.1717 7.7384V7.73842Z",
    fill: "#1C7A17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5049 7.06002L7.70364 12.7674L5.13377 10.2394C4.94609 10.0554 4.64507 10.0563 4.46111 10.2449C4.27715 10.4326 4.27901 10.7336 4.46669 10.9176L7.3701 13.7736C7.46301 13.8647 7.58286 13.9102 7.70364 13.9102C7.82442 13.9102 7.94427 13.8647 8.03718 13.7736L14.172 7.73825C14.3597 7.55429 14.3615 7.25326 14.1775 7.06559C13.9927 6.877 13.6926 6.87608 13.5049 7.06003L13.5049 7.06002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56145 0.9021C4.30981 0.9021 0.0475464 5.16431 0.0475464 10.416C0.0475464 15.6676 4.30981 19.9299 9.56145 19.9299C14.8227 19.9299 19.0754 15.6676 19.0754 10.416C19.0754 5.16431 14.8227 0.9021 9.56145 0.9021ZM14.1717 7.73842L8.0369 13.7738C7.94399 13.8648 7.82414 13.9104 7.70336 13.9104C7.58258 13.9104 7.46273 13.8648 7.36982 13.7738L4.46641 10.9178C4.27873 10.7338 4.27687 10.4328 4.46083 10.2451C4.64479 10.0565 4.94582 10.0556 5.13349 10.2395L7.70336 12.7676L13.5046 7.06018C13.6923 6.87622 13.9924 6.87715 14.1773 7.06575C14.3612 7.25341 14.3594 7.55444 14.1717 7.7384V7.73842Z",
    fill: "#1C7A17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckFilled);
export default __webpack_public_path__ + "static/media/green_check_filled.ab72d84fa556b0ada00b6169785eff3f.svg";
export { ForwardRef as ReactComponent };